import { useState } from "react";
import { faqs } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-50 py-16 md:py-20">
      <div className="mx-auto grid max-w-content gap-10 px-4 md:px-6 lg:grid-cols-[0.85fr_1.15fr]">
        <div>
          <SectionHeading
            eyebrow="常见问题"
            title="关于图集收录，你可能想问"
            desc="关于内容来源、隐私处理与权益申请，这些是我们收录图集时遵循的基本原则。"
          />
          <a
            href="#about"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-100 px-5 py-2.5 text-sm font-semibold text-accent-800 transition hover:bg-accent-200"
          >
            查看内容与版权说明
            <i className="ri-arrow-down-line" />
          </a>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition ${
                  isOpen ? "border-primary-200 bg-primary-50/40" : "border-background-200 bg-background-100/50"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"}`} />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}